import React, { useState } from "react";
import "./Bind_Mailbox.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import { Button, Form } from "react-bootstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";

function Bind_Mailbox() {
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  return (
    <>
      <section className="Bind_Mailbox login-page">
        <Common_white_header headingText={"Bind Mailbox"} />

        <div className="container">
          {/* Confirm Password */}
          <div className="form-group field_holder">
            <Form.Label>
              <img
                src="/assets/images/icons/envolope.png"
                alt="icon"
                className="login_lable_icons"
              />{" "}
              Mail
            </Form.Label>

            <div className="password_input">
              <Form.Control
                type={showConfirmPassword ? "text" : "password"}
                placeholder="Please input your email"
              />
              <span
                className="eye-icon"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              >
                {showConfirmPassword ? <FaEye /> : <FaEyeSlash />}
              </span>
            </div>
          </div>
          {/* Invite Code */}
          <div className="form-group field_holder invite_code_wrapper">
            <Form.Label>
              <img
                src="/assets/images/icons/sheild.png"
                alt="icon"
                className="login_lable_icons"
              />{" "}
              Verification Code
            </Form.Label>

            <div className="invite_input">
              <Form.Control
                type="text"
                placeholder="Please Enter the Confirmation Code"
              />
              <Button className="send_btn">Send</Button>
            </div>
          </div>

          <button class="btn_register_bg mt-4">Bind</button>
        </div>
      </section>
    </>
  );
}

export default Bind_Mailbox;
